import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BookingsService } from 'src/app/api/booking/bookings.service';
import { GlobalService } from 'src/app/api/global.service';
import { SearchComponent } from 'src/app/components/search/search.component';
import { NavigationTrackerService } from 'src/app/utils/navigation-tracker.service';
import SwalAlert from 'src/app/utils/swalalert';
import AlertifyHelper from 'src/app/utils/utils';
import * as moment from 'moment';
declare var $: any;

@Component({
  selector: 'app-receiveds-list',
  templateUrl: './receiveds-list.component.html',
  styleUrls: ['./receiveds-list.component.css']
})
export class ReceivedsListComponent implements OnInit {

  private thisComponent: ReceivedsListComponent;
  branchofficeSlug = '';
  items: any = [];
  params: any = {
    search: ''
  };
  page = 1;
  count = 0;

  @ViewChild(SearchComponent) searchComponent: any;

  dataPagination: any = {
    pageSize: 0,
    currentPage: this.page,
    totalItems: 0
  };

  start_range:any = moment().startOf('month');
  end_range:any = moment().endOf('month');

  constructor(
    private routeActivated: ActivatedRoute,
    private router: Router,
    private bookingsService: BookingsService,
    private globalService: GlobalService,
    private alert: SwalAlert,
    private alertifyMsg: AlertifyHelper,
    private navigationTrackerService: NavigationTrackerService
  ) {
    this.thisComponent = this;
    this.branchofficeSlug = this.globalService.slugBranchoffice;
  }

  
  ngOnInit() {
    let component_ = this.thisComponent;
    (<any>$('#date_range')).daterangepicker({
      locale: {
        format: 'YYYY-MM-DD'
      },
      startDate: component_.start_range,
      endDate: component_.end_range,
      showDropdowns: true,
    },
      function(start_date: any, end_date: any) {
        component_.start_range = start_date;
        component_.end_range = end_date;
        component_.list();
      }  
    );
    this.navigationTrackerService.initializeMenu(this.routeActivated);
    this.list();
  }

  list() {
    let val_params = 'search=' + this.params.search + '&page=' + this.page+
    "&start_range=" + this.start_range.format('YYYY-MM-DD') + '&end_range=' + this.end_range.format('YYYY-MM-DD');
    this.bookingsService.listReceiveds(val_params).subscribe({
      next: (data: any) => {
        this.items = data.results;
        this.dataPagination.pageSize = data.paginate_by;
        this.dataPagination.currentPage = this.page;
        this.dataPagination.totalItems = data.total;
      }
    });
  }

  search(text: any) {
    this.params.search = text;
    this.page = 1;
    this.list();
  }

  handlePageChange(event: any): void {
    this.page = event;
    this.list();
  }

  refresh() {
    this.page = 1;
    this.params.search = '';
    this.searchComponent.textSearch = '';
    this.start_range = moment().startOf('month');
    this.end_range = moment().endOf('month');
    this.list();
  }

  edit(id: number) {
    this.router.navigate([
      this.branchofficeSlug + '/reservas/recibidos/editar',
      id
    ]);
  }

  detail(id: number) {
    this.router.navigate([
      this.branchofficeSlug + '/reservas/recibidos/detalle',
      id
    ]);
  }

  delete(item: any, _index:any) {
    let options = {
      title: '¿Estás segur@?',
      message: " de Recibido "+item.code,
      cancel: 'Cancelar',
      confirm: 'Eliminar'
    };
    this.alert.confirmDelete(options).then((result: any) => {
      if (result.isConfirmed) {
        this.bookingsService.deleteReceiveds(item.id).subscribe({
          next: (data: any) => {
            this.items.splice(_index, 1);
            this.alertifyMsg.success('El registro '+item.code+' se ha eliminado con éxito');
            this.list();
          }
        });
      }
    });
  }
}

